import styled from "styled-components";

export default function WizardChip({ label, selected, onClick }) {
  return (
    <Chip $selected={selected} onClick={onClick}>
      {label}
    </Chip>
  );
}

const Chip = styled.button`
  appearance: none;
  border: 1px solid ${(p) => (p.$selected ? "#182941" : "#d1d5db")};
  background: ${(p) => (p.$selected ? "#182941" : "#fff")};
  color: ${(p) => (p.$selected ? "#fff" : "#374151")};
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.15s;
  font-weight: ${(p) => (p.$selected ? 600 : 400)};

  &:hover {
    border-color: #182941;
  }
`;
